export const ErrorBanner = () => {
    return <div className="error-banner">Some error occurred. Please contact your administrator</div>
}